import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { SearchStatsPanel } from "@/components/SearchStatsPanel";
import { ResultsTable } from "@/components/ResultsTable";
import { ArrowLeft } from "lucide-react";

export default function SearchDetailPage() {
  const { id } = useParams();
  const [search, setSearch] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get(`/searches/${id}`);
        setSearch(res.data);
      } catch (e) {
        toast.error("Recherche introuvable");
      }
    })();
  }, [id]);

  return (
    <div className="p-6 space-y-6" data-testid="search-detail-page">
      <Link
        to="/recherches"
        data-testid="back-to-history-link"
        className="inline-flex items-center gap-1 font-mono text-xs uppercase tracking-wider text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft size={14} /> Retour a l'historique
      </Link>
      <SearchStatsPanel search={search} />
      <ResultsTable searchId={id} />
    </div>
  );
}
